module.exports = __webpack_public_path__ + "static/media/vbm_blk.13879cee.png";